import { User } from 'oidc-client';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { showLogInfo } from 'src/constants/profileSettings';
import { LandingPage } from '../../components/Landingpage/LandingPage';
import { IState } from '../../store/reducer';
import Callback from '../oidc/Callback';
import { toggleLogInfo } from './../../store/actions/index';
// import { history } from './../../store/store';
import MainComponent from './MainComponent';



interface IProps {
  user: User
  toggleInfo: (bool: showLogInfo) => void;
}



const Main: React.SFC<IProps> = (props) => {
  const { user } = props;
  if (window.location.pathname.endsWith("index.html")) {
    if (window.location.href.endsWith("signed-out")) {
      window.location.href = "/"
    }
    if (window.location.href.includes("#error")) {
      window.location.href = "/"
    }
    return <Callback />
  } else {
    return !user || user.expired ? <LandingPage /> : <MainComponent toggleInfo={props.toggleInfo} />
  }
};

const mapStateToProps = (state: IState) => {
  return {
    user: state.oidc.user
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    toggleInfo: (bool: showLogInfo) => toggleLogInfo(dispatch, bool),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/Containers/main/Main.tsx